import './AevocamInOutMark.css'

export type AevocamInOutMarkProps = {
  /** Opening bracket `[` or closing `]` (horizontal flip). */
  variant: 'left' | 'right'
  /** Outer stroke width in viewBox units. */
  outerStrokeWidth?: number
  /** Inner stroke width in viewBox units. */
  innerStrokeWidth?: number
}

const VB_W = 12
const VB_H = 48

/**
 * Tall thin bracket stroke for in/out marks: round joins/caps, rim + accent strokes from CSS.
 * Geometry is defined in viewBox space; size with CSS `width` / `height` on the svg or a parent.
 */
export function AevocamInOutMark({
  variant,
  outerStrokeWidth = 5,
  innerStrokeWidth = 2.5,
}: AevocamInOutMarkProps) {
  const points = '10.2,4.5 3.2,4.5 3.2,43.5 10.2,43.5'
  const flip = variant === 'right' ? `scale(-1,1) translate(-${VB_W},0)` : undefined

  return (
    <svg
      className='AevocamInOutMark'
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <g transform={flip}>
        <polyline
          className='Rim'
          points={points}
          strokeWidth={outerStrokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <polyline
          className='Accent'
          points={points}
          strokeWidth={innerStrokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
